export enum FilingNoteEnum {
    ARQUIVADO = 1,
    SOLICITADO_DESARQUIVAMENTO = 2,
    DESARQUIVADO = 3,
    REJEITADO = 4
}